import React from "react";

// styles
import styles from "./styles.module.scss";

import Button from "../Button/Button";

const Footer = ({ label, btnLabel, text, fill, handleChange }) => {
  return (
    <div className={styles.footer}>
      <p className={styles.label}>{label}</p>
      <Button label={btnLabel} fill={fill} handleClick={handleChange} />
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default Footer;
